<template>
  <div class="es-wrap">
    <div class="es-icon-wrap" :style="{ background: iconBg }">
      <fa-icon :icon="icon" :style="{ color: iconColor }" />
    </div>
    <h3 class="es-title">{{ title }}</h3>
    <p v-if="message" class="es-msg">{{ message }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: { type: Array, required: true },
    iconBg: { type: String, default: '#f3f4f6' },
    iconColor: { type: String, default: '#9ca3af' },
    title: { type: String, default: 'Nothing here yet' },
    message: { type: String, default: '' }
  }
}
</script>
